import type { Draft } from 'immer'
import isArray from 'lodash/isArray'
import some from 'lodash/some'
import toPairs from 'lodash/toPairs'
import type { PayableFormDirty } from '@klear/payable/wire.client'

export type PayableFormFieldPath =
  | 'supplierId'
  | 'currency'
  | 'orderId'
  | 'purchaseOrderId'
  | 'operationalEventIds'
  | 'items'
  | 'parentEventId'
  | 'payment'
  | 'publishAction'
  | 'effectiveDate'

export function markPayableFormDirty(draft: Draft<PayableFormDirty>, path: PayableFormFieldPath): void {
  draft[path] = true
}

export function markPayableFormDirtyPaths(
  draft: Draft<PayableFormDirty>,
  paths: PayableFormFieldPath | readonly PayableFormFieldPath[]
): void {
  const dirtyPaths = isArray(paths) ? paths : [paths]
  for (const path of dirtyPaths) {
    markPayableFormDirty(draft, path)
  }
}

const PAYABLE_URL_RESUMABLE_DIRTY_KEYS = new Set<keyof PayableFormDirty>([
  'supplierId',
  'currency',
  'orderId',
  'purchaseOrderId',
  'operationalEventIds',
  'items',
  'parentEventId'
])

export function hasPayableFormChanges(dirty: PayableFormDirty): boolean {
  return some(dirty, (value) => value === true)
}

export function isPayableLeaveDirty(dirty: PayableFormDirty): boolean {
  for (const [key, value] of toPairs(dirty)) {
    if (value !== true) continue
    if (PAYABLE_URL_RESUMABLE_DIRTY_KEYS.has(key as keyof PayableFormDirty)) continue
    return true
  }
  return false
}
